import { api, store } from "./index";
import { closeAllMenus } from "./helpers/Menus";
import { showMessage } from "./Message";
import { t } from "./helpers/Translate";

class License {
  constructor(urlKey) {
    this.valid = false;
    this.key = urlKey || localStorage.getItem("licence_key") || null;

    if (this.key) {
      this.validate(this.key);
    } else {
      document.querySelector("#upgrade-button").style.display = "inline-flex";
    }
  }

  async validate(key) {
    if (!key) return;
    key = key.trim();
    if (!key) return;
    // ":v2" invalidates the old 60-day cookies so every key gets a fresh server check
    if (this.isMonsterValid(this.hash(key + ":v2"))) {
      setTimeout(
        () => this.validKey(key, JSON.parse(localStorage.getItem("user_data"))),
        300
      );
    } else {
      api.validateLicenseKey(key).then(data => {
        // Keep a saved key when validation could not complete; allow a retry.
        if (data === null) {
          // Offline or outage: trust a stored key without renewing the cookie, so lapsed keys still fail on the next completed check
          const cachedData = JSON.parse(localStorage.getItem("user_data"));
          if (key === localStorage.getItem("licence_key") && cachedData) {
            this.validKey(key, cachedData);
          } else {
            showMessage("Unable to reach the license service. Please try again shortly.", 6000);
            document.querySelector("#upgrade-button").style.display = "inline-flex";
          }
          return;
        }
        if (data) {
          // Only welcome new activations, not the 7-day revalidation of a stored key
          if (key !== localStorage.getItem("licence_key")) {
            showMessage(
              "<b>💃 Welcome to JustSketchMe Pro! 🕺</b> <br> All of the features and models have been unlocked!",
              4000
            );
          }
          // Only a server check renews the offline cookie, so expired keys stop working within 7 days
          this.setMonster(this.hash(key + ":v2"), 7);
          this.validKey(key, data);
        } else {
          this.invalidKey();
        }
      });
    }
  }

  validKey(key, data) {
    this.valid = true;
    this.key = key;

    localStorage.setItem("licence_key", key);
    localStorage.setItem("user_data", JSON.stringify(data));
    store.setState({ user: data });
    document.querySelector("#upgrade-button").style.display = "none";
    closeAllMenus();
    this.getAllInfo(key);
  }

  invalidKey() {
    this.valid = false;
    localStorage.removeItem("licence_key");
    localStorage.removeItem("user_data");
    this.setMonster("", -1);
    this.key = null;
    document.querySelector("#upgrade-button").style.display = "inline-flex";
  }

  getAllInfo(key) {
    api.getScenes(key).then(data => {
      if (data) {
        store.setState({ savedScenes: data });
      }
    });
    api.getPoses(key).then(data => {
      if (data) {
        store.setState({ savedPoses: data });
      }
    });
  }

  check() {
    closeAllMenus();
    if (!this.valid) {
      openMenu("#upgrade-button", "#upgrade-menu");
    }
    return this.valid;
  }

  prompt() {
    const key = prompt(t("Enter your license key"));
    if (key) {
      this.validate(key);
    }
  }

  clear() {
    localStorage.removeItem("licence_key");
    location.reload();
  }

  setMonster(value, length) {
    const date = new Date();
    date.setTime(date.getTime() + length * 24 * 60 * 60 * 1000);
    let expires = "expires=" + date.toUTCString();
    document.cookie = "monster=" + value + ";" + expires + ";path=/";
  }

  isMonsterValid(value) {
    let decodedCookie = decodeURIComponent(document.cookie);
    return (
      decodedCookie.substring(decodedCookie.indexOf("=") + 1, 999) == value
    );
  }

  hash(string) {
    let hash = 0;

    if (string.length == 0) {
      return hash;
    }
    for (let i = 0; i < string.length; i++) {
      let ch = string.charCodeAt(i);
      hash = (hash << 5) - hash + ch;
      hash = hash & hash;
    }
    return hash;
  }
}

export default License;
